import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { inject } from '@angular/core';
import { SsoDomainService } from '../../core/services/sso-domain.service';

export function blockedDomainsValidator(): ValidatorFn {
  const ssoDomainService = inject(SsoDomainService);
  
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    
    const domain = control.value.toLowerCase();
    const blockedDomains = ssoDomainService.blockedDomains;
    
    return blockedDomains.includes(domain) 
      ? { blockedDomain: { value: control.value } }
      : null;
  };
}